import React from 'react';
import { createComponent, Panel, IsInvertedProvider, Input, Button, PropTypes, Layout, enums } from 'console-kit';

const DesignerTestTab = createComponent({
  displayName: 'designerTestTab',
  propTypes:   {
    id:                 PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isSendingTestEmail: PropTypes.bool,
    from:               PropTypes.string,
    emailTemplate:      PropTypes.object,
    token:              PropTypes.shape({
      required: PropTypes.array,
      known:    PropTypes.array,
      unknown:  PropTypes.array,
    }),
    previewEmail:             PropTypes.string,
    checkEmailTemplateTokens: PropTypes.func.isRequired,
    sendPreviewEmailTemplate: PropTypes.func.isRequired,
    setPreviewEmail:          PropTypes.func.isRequired,
  },
  defaultProps: {
    isSendingTestEmail: false,
    previewEmail:       '',
    from:               '',
    token:              {
      required: [],
      known:    [],
      unknown:  [],
    },
    emailTemplate: {},
  },
  handlers: {
    _sendPreviewEmailTemplate: (props) => () => {
      props.sendPreviewEmailTemplate(props.previewEmail, props.emailTemplate.instanceConfig);
    },
  },
  lifecycles: {
    shouldComponentUpdate(nextProps) {
      return !_.isEqual(this.props, nextProps);
    },

    UNSAFE_componentWillMount() {
      this.props.checkEmailTemplateTokens(this.props.emailTemplate.instanceConfig);
    },
  },
  render(props) {
    return (
      <IsInvertedProvider isInverted={true}>
        <div>
          <Panel
            header="Send test email"
            hasBorder={false}
            byline="You should test emails on common email clients and online email providers, as each one renders email slightly differently."
          >
            <Layout>
              <Layout.Row>
                <Layout.Column columnWidth={enums.widths.EIGHT}>
                  <Input
                    action={{
                      content:  <Button.Primary color="accent" text="Send" onClick={props._sendPreviewEmailTemplate} />,
                      position: enums.positions.RIGHT,
                    }}
                    hasError={false}
                    isFluid={true}
                    value={props.previewEmail}
                    placeholder="account@email.com"
                    type="email"
                    label="Send test email to"
                    onChange={props.setPreviewEmail}
                    isDisabled={props.isSendingTestEmail}
                    isLoading={props.isSendingTestEmail}
                  />
                </Layout.Column>
              </Layout.Row>
            </Layout>
          </Panel>
        </div>
      </IsInvertedProvider>
    );
  },
});

export default DesignerTestTab;
